let metierValue = null
let iduser = null
let typedroit = null
let typeuser = null
let environnement = null
let uuid = null
export default {
  setMetier(metier) {
    if (metierValue !== null) {
      return
      //throw new Error('[environnement] Le metier a déjà été défini et ne peut plus être modifié.')
    }
    metierValue = metier
  },

  getMetier() {
    return metierValue
  },

  setIDuser(id) {
    if (iduser !== null) {
      return
      //throw new Error('[environnement] L\'ID utilisateur a déjà été défini et ne peut plus être modifié.')
    }
    iduser = id
  },

  getIDuser() {
    return iduser
  },

  setUIDuser(id) {
    if (iduser !== null) {
      return
      //throw new Error('[environnement] L\'ID utilisateur a déjà été défini et ne peut plus être modifié.')
    }
    uuid = id
  },

  getUIDuser() {
    return uuid
  },

  setTypeDroit(id) {
    if (typedroit !== null) {
      return
      //throw new Error('[environnement] L\'ID utilisateur a déjà été défini et ne peut plus être modifié.')
    }
    typedroit = id
  },

  getTypeDroit() {
    return typedroit
  },

    setTypeUser(id) {
    if (typeuser !== null) {
      return
      //throw new Error('[environnement] L\'ID utilisateur a déjà été défini et ne peut plus être modifié.')
    }
    typeuser = id
  },

  getTypeUser() {
    return typeuser
  },

    setEnv(id) {
    if (environnement !== null) {
      return
      //throw new Error('[environnement] L\'ID utilisateur a déjà été défini et ne peut plus être modifié.')
    }
    environnement = id
  },

  getEnv() {
    return environnement
  }
  
}